import { Trans, useTranslation } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function DeadlineSet({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  const { t } = useTranslation();
  const ideaStr = util.pluralise(
    events.length,
    t("generic.idea"),
    t("generic.ideas"),
    false,
  );
  return (
    <Trans
      i18nKey="notifications.ideaDeadlineSet"
      values={{ ideaStr, ideas: util.getEventNames(events, "ownerIdea") }}
    />
  );
}
